import { render, staticRenderFns } from "./ClienteCuentaCorrienteMovimientos.vue?vue&type=template&id=b7249476&scoped=true&"
import script from "./ClienteCuentaCorrienteMovimientos.vue?vue&type=script&lang=js&"
export * from "./ClienteCuentaCorrienteMovimientos.vue?vue&type=script&lang=js&"
import style0 from "./ClienteCuentaCorrienteMovimientos.vue?vue&type=style&index=0&id=b7249476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7249476",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VPagination,VProgressLinear,VSelect,VSpacer})
